<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" v-bind:href="'#t1'+rowData.monprol_id+''" role="tab" data-toggle="tab">
						<span class="nav-link-in">
							Detalhes
							<i class="fa fa-bulding"></i>
						</span>
					</a>
				</li>
			</ul>

			<div class="tab-content">
				<div role="tabpanel" class="tab-pane fade in active show"  v-bind:id="'t1'+rowData.monprol_id+''">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th>Erro técnico</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;">
                                <td>
                                    {{ rowData.erro_tecnico }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
 </template>

  <script>
  import moment from 'moment'
  export default {
      data () {
        return {
          helpForm: new Form({statusRecord: [], params: []}),
          cnpj_formatado: ''
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
        formatDate (value, fmt = 'DD/MM/YYYY HH:mm') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
        },
    },
  }
  </script>
